function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grad6",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#cc31ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90%",
  stopColor: "#19f2c8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#grad6)",
  d: "M30 11.25C17.5 11.25 6.825 19.025 2.5 30c4.325 10.975 15 18.75 27.5 18.75S53.175 40.975 57.5 30c-4.325-10.975-15-18.75-27.5-18.75zm0 31.25c-6.9 0-12.5-5.6-12.5-12.5S23.1 17.5 30 17.5 42.5 23.1 42.5 30 36.9 42.5 30 42.5zm0-20a7.49 7.49 0 0 0-7.5 7.5c0 4.15 3.35 7.5 7.5 7.5s7.5-3.35 7.5-7.5-3.35-7.5-7.5-7.5z",
  opacity: 0.654
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h60v60H0z"
}));

var SvgBehaviour = function SvgBehaviour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBehaviour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/behaviour.4d0f9895.svg";
export { ForwardRef as ReactComponent };